import React, { useLayoutEffect, useRef } from 'react';

const StickOnScrollWrapper = ({
  children,
  active,
  topMargin = 0,
}: {
  readonly active: boolean;
  readonly children: React.ReactNode;
  readonly topMargin?: number;
}) => {
  const targetRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const targetElement = targetRef.current;
    if (targetElement?.parentElement) {
      targetElement.parentElement.style.height = 'inherit';
    }

    return () => {
      if (targetElement?.parentElement) {
        targetElement.parentElement.style.height = '';
      }
    };
  }, []);

  return (
    <div
      className={active ? 'sticky' : ''}
      ref={targetRef}
      style={{
        ...(active ? { top: topMargin } : {}),
      }}
    >
      {children}
    </div>
  );
};
export { StickOnScrollWrapper };
